module.exports = __webpack_public_path__ + "img/facepaint-4_jp.b3c3a34.jpg";